import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { AbstractBaseComponent } from 'src/app/model/AbstractBaseComponent';
import { SelectDTO } from 'src/app/model/newModel';
import {
  BoxPrenotazioneLaboratorioDTO,
  ListBoxPrenotazioneLaboratorioDTO,
} from '../../../../model/newModel';
import { SharedService } from '../../../../shared/shared.service';
import { PrenotazioneLaboratorioService } from './prenotazione-laboratorio.service';

@Component({
  selector: 'app-prenotazione-laboratorio',
  templateUrl: './prenotazione-laboratorio.component.html',
  styleUrls: ['./prenotazione-laboratorio.component.css'],
})
export class PrenotazioneLaboratorioComponent
  extends AbstractBaseComponent
  implements AfterViewInit, OnInit, OnDestroy {
  options = {
    format: 'DD/MM/YYYY',
  };
  boxesLaboratori: BoxPrenotazioneLaboratorioDTO[];
  tutors: SelectDTO[];
  idTutor: number;
  dataCorrente: Date;
  showPrenotazioni: boolean;

  ngOnInit(): void {
    super.ngOnInit();
    if (!!this.student.gruppoStudio && this.student.gruppoStudio.active) {
      this.selectAllActiveTutors();
      this.showPrenotazioni = true;
    } else {
      this.showPrenotazioni = false;
    }
  }

  search(idTutor: number, dataCorrente: Date) {
    this.spinner.show();
    this.prenotazioneLaboratorioService.search(idTutor, dataCorrente).subscribe(
      (result: ListBoxPrenotazioneLaboratorioDTO) => {
        this.spinner.hide();
        this.boxesLaboratori = result.boxesPrenotazioneLaboratorio;
      },
      (error) => {
        this.spinner.hide();
        console.log('Errore search');
      }
    );
  }

  private selectAllActiveTutors() {
    this.sharedService.selectTutors().subscribe(
      (result) => {
        const allTypes = new SelectDTO();
        allTypes.value = '';
        allTypes.viewValue = 'TUTTI';
        this.tutors = result.list;
        this.tutors.unshift(allTypes);
      },
      (error) => {
        console.log('Errore selectTutors');
      }
    );
  }

  prenota(obj: any) {
    this.spinner.show();

    if (this.student.verificaOrePrenotazione) {
      // VERIFICO SE HO GIA' PIU' 2 PRENOTAZIONI PER LA STESSA DATA
      this.prenotazioneLaboratorioService
        .verificaPrenotazioni(obj, this.student.id)
        .subscribe(
          (resultVerifica: boolean) => {
            // resultVerifica == true non ci sono 2 prenotazioni per la stessa data
            if (resultVerifica) {
              this.prenotazione(obj);
            } else {
              this.spinner.hide();
              const text =
                'Non si possono prenotare più di 2 laboratori nella stessa data!';
              this.sharedService.openWarningModal(text);
            }
          },
          (error) => {
            console.log('Errore verificaPrenotazione');
          }
        );
    } else {
      this.prenotazione(obj);
    }
  }

  private prenotazione(obj: any) {
    this.prenotazioneLaboratorioService
      .creaPrenotazione(obj, this.student.id)
      .subscribe(
        (result: boolean) => {
          if (result) {
            this.spinner.hide();
            this.ngxSmartModalService.getModal('okModalPrenotazione').open();
          } else {
            this.spinner.hide();
            this.ngxSmartModalService.getModal('koModalPrenotazione').open(); // SEI GIA PRENOTATO
          }
        },
        (error) => {
          console.log('Errore creaPrenotazione');
        }
      );
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  constructor(
    private spinner: NgxSpinnerService,
    public ngxSmartModalService: NgxSmartModalService,
    private sharedService: SharedService,
    private prenotazioneLaboratorioService: PrenotazioneLaboratorioService
  ) {
    super();
  }
}
